import { asDollars } from "app/frontend/utils/currency";
import { removeNonDigits } from "app/frontend/utils/phone";

export const CURRENCY_INPUT_TRANSFORMER = {
  input: (value: string | number) =>
    asDollars(Number(removeNonDigits(value as string))),
  output: (e: React.ChangeEvent<any>) => removeNonDigits(e.target.value),
};

export const toId = (s: string | undefined) =>
  s?.replaceAll(" ", "-").replaceAll("/", "").toLowerCase().trim();
